import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AIEngine } from '../models/aiengine.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class AiengineService {

	private svcUrl = '/AIEngines';

	constructor(private http: HttpClient, private url: UrlService) {

	}

	getAIEngines(): Observable<AIEngine[]> {
		return this.http.get<AIEngine[]>(this.url.getBaseURL() + this.svcUrl);
	}

	getAIEngine(id: number): Observable<AIEngine> {
		return this.http.get<AIEngine>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	createAIEngine(item: AIEngine): Observable<AIEngine> {
		return this.http.post<AIEngine>(this.url.getBaseURL() + this.svcUrl, item);
	}

}

